import React from "react";
import { Checkbox, Grid, IconButton, Paper, Typography } from "@material-ui/core";
import withIntl from "../../utils/withIntl";
import PrinterType from "./PrinterType";
import { useDialog } from "../Dialogs/DialogProvider";
import { Edit, FileCopy } from "@material-ui/icons";
import PrinterDetails from "./PrinterDetails";
import DuplicatePrinter from "./DuplicatePrinter";
import { Tooltip } from "react-bootstrap";

function Printer(props) {
  const [printer, setPrinter] = React.useState(props.printer);
  const [openDialog] = useDialog();

  return (
    <Paper style={{ width: "450px", padding: "16px", margin: "16px" }}>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          {printer.description}
        </Grid>
        <Grid item xs={4}>
          {printer.comment}
        </Grid>
        <Grid item xs={3}>
          <PrinterType printer={printer} />
        </Grid>
        <Grid item xs={1}>
          <IconButton
            size={"small"}
            onClick={() => {
              openDialog({
                children: (
                  <PrinterDetails
                    printer={printer}
                    onPrinterUpdate={(newPrinter) => {
                      let tempPrinter = { ...printer, ...newPrinter };
                      setPrinter(tempPrinter);
                    }}
                  />
                ),
                fullWidth: true,
                maxWidth: "xl",
              });
            }}
          >
            <Edit />
          </IconButton>
        </Grid>

        <Grid item xs={4}>
          {printer.address}
        </Grid>

        <Grid item xs={12}>
          <div style={{ display: "inline" }}>
            {props.intl.formatMessage({ id: "is_bill_printer" })}
            <Checkbox color={"primary"} checked={!!printer.is_pin_printer} disabled />
          </div>
        </Grid>

        <Grid item xs={12} container spacing={1}>
          <Grid item xs={12}>
            <Typography>{props.intl.formatMessage({ id: "print_groups" })}</Typography>
          </Grid>
          {printer.printer_tags.map((printerTag) => {
            return (
              <Grid item xs={12}>
                {printerTag.tag} - {props.intl.formatMessage({ id: "print_setting_" + printerTag.setting })}
              </Grid>
            );
          })}
        </Grid>

        {printer.mynbonnen_users.length > 0 && (
          <Grid item xs={12} container spacing={1}>
            <Grid item xs={12}>
              <Typography>{props.intl.formatMessage({ id: "orders_users" })}</Typography>
            </Grid>
            {printer.mynbonnen_users.map((mynbonnenUser) => {
              return (
                <Grid item xs={12}>
                  {mynbonnenUser.email}
                </Grid>
              );
            })}
          </Grid>
        )}
        {printer.pillar_users.length > 0 && (
          <Grid item xs={12} container spacing={1}>
            <Grid item xs={12}>
              <Typography>{props.intl.formatMessage({ id: "kiosk_users" })}</Typography>
            </Grid>
            {printer.pillar_users.map((pillarUser) => {
              return (
                <Grid item xs={12}>
                  {pillarUser.email}
                </Grid>
              );
            })}
          </Grid>
        )}

        <Grid item xs={12} container justify={"flex-end"}>
          <Tooltip title={props.intl.formatMessage({ id: "duplicate_printer" })}>
            <IconButton
              size={"small"}
              onClick={() => {
                openDialog({ children: <DuplicatePrinter printer={printer} /> });
              }}
            >
              <FileCopy />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default withIntl(Printer);
